// pm-mocks/src/data/behavioralQuestions.js

const behavioralQuestionsBank = [
    "Can you describe a challenging project you worked on and how you handled it?",
    "Tell me about a time when you had to lead a team through a difficult situation.",
    "How do you prioritize tasks when managing multiple projects?",
    "Describe a situation where you had to make a quick decision without all the necessary information.",
    "Tell me about a time when you had to collaborate with a difficult colleague.",
    "How do you handle tight deadlines and pressure?",
    "Describe a situation where you had to adapt to significant changes at work.",
    "Can you provide an example of a goal you set and how you achieved it?",
    "Tell me about a time when you failed and how you dealt with it."
  ];
  
  export default behavioralQuestionsBank;